module.exports = __webpack_public_path__ + "media/ghost.2400fdbd.mp3";